import { createContext } from "react";

const PsychologicalAssessment = createContext();

export default PsychologicalAssessment;
